/* custom-atlas.js */

document.addEventListener('DOMContentLoaded', () => {
    initVariantSelection();
    initCalculator();
});

function initVariantSelection() {
    const radioInputs = document.querySelectorAll('input[name="config_option"]');
    const standardGroup = document.querySelector('.option-group[data-type="standard"]');
    const m2mGroup = document.querySelector('.option-group[data-type="m2m"]');
    
    // Toggle Groups
    radioInputs.forEach(radio => {
        radio.addEventListener('change', (e) => {
            document.querySelectorAll('.option-group').forEach(g => g.classList.remove('active'));
            const selectedGroup = e.target.closest('.option-group');
            selectedGroup.classList.add('active');
            
            // If switching to M2M, might need to update price display or reset selection
            if(e.target.value === 'm2m') {
                updatePriceDisplay(120, true);
                // Select internal variant for M2M if exists
            } else {
                updatePriceDisplay(85);
            }
        });
    });

    // Handle Standard Length Buttons
    const lengthBtns = document.querySelectorAll('.length-btn');
    lengthBtns.forEach(btn => {
        btn.addEventListener('click', function() {
            // Remove active from all
            lengthBtns.forEach(b => b.classList.remove('active'));
            this.classList.add('active');
            
            // Update Hidden ID
            updateMasterSelect(this.dataset.variantId);
            
            // Ensure standard radio is checked
            const stdRadio = document.querySelector('input[value="standard"]');
            if(stdRadio && !stdRadio.checked) {
                stdRadio.click();
            }
        });
    });
}

function updateMasterSelect(id) {
    const select = document.querySelector('select[name="id"]');
    if(select) {
        select.value = id;
        select.dispatchEvent(new Event('change', { bubbles: true }));
    }
}

function updatePriceDisplay(price, from = false) {
    const priceEl = document.querySelector('.price-display');
    if(priceEl) {
        priceEl.textContent = (from ? 'From ' : '') + '£' + price;
    }
}

function initCalculator() {
    const calcInputs = document.querySelectorAll('.calc-input');
    const resultEl = document.querySelector('#calc-result-value');
    const pdfBtn = document.querySelector('.save-pdf');
    
    calcInputs.forEach(input => {
        input.addEventListener('input', calculate);
    });

    function calculate() {
        const coverage = parseFloat(document.getElementById('calc-coverage')?.value) || 0;
        const clearance = parseFloat(document.getElementById('calc-clearance')?.value) || 0;
        const bracket = document.getElementById('calc-bracket')?.value;
        
        if(coverage > 0) {
            let extra = 70; // 35mm * 2 default
            if(bracket === 'Recess') extra = 50;
            if(bracket === 'Pedestal') extra = 90;
            
            const total = coverage + (clearance * 2) + (extra / 10); // cm
            resultEl.textContent = Math.ceil(total) + ' cm';
        } else {
            resultEl.textContent = '—';
        }
    }
    
    if(pdfBtn) {
        pdfBtn.addEventListener('click', () => {
             alert('Generating PDF Specification Sheet...');
        });
    }
}
